import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUsers, FaHandshake, FaChartLine, FaAward, FaClock } from 'react-icons/fa';
import { VscWorkspaceTrusted } from 'react-icons/vsc';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
    const { t } = useTranslation();

    const features = [
        {
            icon: <VscWorkspaceTrusted />,
            titleKey: 'whyChooseUs.trust.title',
            descKey: 'whyChooseUs.trust.description',
        },
        {
            icon: <FaUsers />,
            titleKey: 'whyChooseUs.community.title',
            descKey: 'whyChooseUs.community.description',
        },
        {
            icon: <FaHandshake />,
            titleKey: 'whyChooseUs.service.title',
            descKey: 'whyChooseUs.service.description',
        },
        {
            icon: <FaChartLine />,
            titleKey: 'whyChooseUs.growth.title',
            descKey: 'whyChooseUs.growth.description',
        },
        {
            icon: <FaAward />,
            titleKey: 'whyChooseUs.excellence.title',
            descKey: 'whyChooseUs.excellence.description',
        },
        {
            icon: <FaClock />,
            titleKey: 'whyChooseUs.availability.title',
            descKey: 'whyChooseUs.availability.description',
        }
    ];

    return (
        <section className="py-20 bg-primary-dark/5 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">{t('whyChooseUs.badge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">{t('whyChooseUs.title')}</h2>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-lg text-gray-600 leading-relaxed">{t('whyChooseUs.subtitle')}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="p-8 rounded-lg bg-white border-t-4 border-gray-200 hover:border-secondary shadow-md hover:shadow-xl transition-all duration-300 group"
                        >
                            <div className="w-14 h-14 rounded-lg bg-gray-50 flex items-center justify-center text-3xl mb-6 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors">{t(feature.titleKey)}</h3>
                            <p className="text-gray-500 leading-relaxed text-sm md:text-base">{t(feature.descKey)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
